import { SelectionModel } from '@angular/cdk/collections';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../general.service';
import { DataService } from '../data.service';

@Component({
  selector: 'app-claims',
  templateUrl: './claims.component.html',
  styleUrls: ['./claims.component.css'],
})
export class ClaimsComponent {
  constructor(
    private s: GeneralService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private toaster: ToastrService,
    private r: Router,
    private DataService: DataService
  ) {
    this.minDate = new Date();
    this.user = JSON.parse(localStorage.getItem('user')!);
  }
  minDate: Date;
  dataSource: any;
  displayedColumns: string[] = [
    'claim_number',
    'policy_number',
    'incident_location',
    'incident_date',
    'destination',
    'gross_premium',
    'status',
    'view',
  ];
  data: any[] = [];
  user: { [key: string]: string } = {};
  non = false;

  @ViewChild(MatSort)
  sort!: MatSort;

  sanctionedStatus = [
    { value: 'pending', viewValue: 'Pending' },
    { value: 'paid', viewValue: 'Paid' },
  ];

  ngOnInit(): void {
    const email = this.user['email'];
    this.s.getAClaim({ email: email }).subscribe({
      next: (res: any) => {
        this.s.loader = false;
        console.log(res);
        this.data = res.data.reverse();
        this.dataSource = new MatTableDataSource(this.data);
      },
      error: (err) => {
         this.non = true
         console.error(err)
      }
    });
  }

  viewClaimDetails(data: any) {
    this.DataService.setData(data);
    this.r.navigateByUrl('main/claimDetails');
  }
}
